<template>
  <PainelLayout>
    <Breadcrumb :lista="[ { 'name':'Painel', 'link' : '/' }]" />
    
    <div class="row">
      <div class="col-6">
        <h1>Clientes</h1>
      </div>
      <div class="col-6 text-end">
        <router-link to="/client/new">
          <button class="btn btn-primary mt-3">Adicionar Item</button>
        </router-link>
      </div>
    </div>
    <hr/>

    <app-table v-if="!loading" empty-message='nada encontrado'
    :colunas="[{ label: '' }, { label: 'Nome' }, {label: 'Whatsapp'},{label: 'Cidade'}, {label: ''}]">
      <app-trow
        v-for="item in lista" :key="item.id"
        :data="[
          {value: item.id},
          {value: item.name},
          {value: item.phone},
          {value: item.city}
        ]"
      >
      <template #actions>
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/client/details', query: { id: item.id } }">
          <i class="bi bi-file-earmark-text me-2"></i>Ver +
        </router-link>
      </template>
      </app-trow>
    </app-table>

    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- Modal de Delete -->
    <div class="modal fade" id="modal_delete" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Confirmar Exclusão</h5>
              <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center">
            <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem;"></i>
            <p class="mt-3">Tem certeza que deseja excluir o cliente <strong>{{ clientobj.name }}</strong>?</p>
            <p class="text-muted small">Esta ação não pode ser desfeita.</p>
          </div>
          <div class="modal-footer">
              <button type="button" @click="closeModal" class="btn btn-secondary">Cancelar</button>
              <button type="button" @click="confirmExcluir" class="btn btn-danger">Excluir</button>
          </div>
        </div>  
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive } from 'vue';
import { Modal } from 'bootstrap';
import { clientes } from '@/models/clientes';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

export default {
  name: "ClientView",
  components: {
    PainelLayout, Breadcrumb, AppTable, AppTrow
  },
  setup(props) {

    const toastStore = useToastStore();
    const lista = ref([]);
    const model = clientes();
    const loading = ref(false);

    let modal = '';
    var advancedMode = ref(false);
    const clientobj = reactive({
      id: null,
      name: ''
    });

    const { isAdmin, isUser, isOpeto } = usePermissions();

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete(item) {
      clientobj.id = item.id;
      clientobj.name = item.name;
      openModal('modal_delete');
    }

    function confirmExcluir() {
      model.delet(clientobj.id).then(() => {
        toastStore.success('Cliente excluído com sucesso.');
        closeModal();
        list();
      }).catch((error) => {
        toastStore.error('Erro ao excluir cliente: ' + parseError(error));
      });
    }

    async function list() {
      loading.value = true;
      try {
        lista.value = await model.list();
      } catch (error) {
        console.error('Erro ao listar clientes:', error);
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => {
      list();
    });

    return {
      lista,
      advancedMode,
      closeModal,
      openModal,
      showModal_delete,
      confirmExcluir,
      clientobj,
      isAdmin,
      isUser,
      isOpeto
    }
  }
}
</script>